import { get, writable } from 'svelte/store';
import config from '../config';

const { subscribe, set, update } = writable({});

const token = createToken({
  id: null,
  stream: null,
  clusterId: null,
  clusterBoundaries: null,
  snapshot: null,
  x: 50,
  y: 50,
});

function createToken(init) {
  set(init);

  return {
    set,
    subscribe,
    getProximity,
    getNearestInRangePeerId,
    isStillInCluster,
    updateClusterBoundaries,
    toggleMic,
  };
}

/* ================================================================*/

const threshold = config.clusterThreshold;

function getNearestInRangePeerId(peers) {
  let inRangePeers = {}; // ex: { 6: 12345, 4: 23456 }
  for (let peerId in peers) {
    const proximity = getProximity(peers[peerId]);
    if (proximity <= threshold) inRangePeers[proximity] = peerId;
  }
  const proximities = Object.keys(inRangePeers);
  const nearest = Math.min(...proximities);
  return inRangePeers[nearest];
}

function isStillInCluster(peers) {
  console.log('isStill');
  // Return true if at least one peer is still within range.
  for (let peerId in peers) {
    const proximity = getProximity(peers[peerId]);
    if (proximity && proximity <= threshold) return true;
  }
  return false;
}

function getProximity(peer) {
  // console.log('peer:', peer);
  const { x, y } = get(token);
  const xProximity = Math.abs(peer.x - x);
  const yProximity = Math.abs(peer.y - y);

  let proximity;

  if (xProximity <= threshold && yProximity <= threshold) {
    // Roughly in range, let's spend the cycles to calculate real proximity.
    proximity = Math.sqrt(Math.pow(x - peer.x, 2) + Math.pow(y - peer.y, 2));
  }
  console.log('proximity:', proximity);
  return proximity;
}

function updateClusterBoundaries(peers) {
  // Set the value of clusterBoundaries to an object: { top, right, bottom, left }
  // Based on token.x/y and x/y props of all peers in current cluster.
  update((token) => {
    let boundaries;

    // If not in a cluster, no boundaries.
    if (!token.clusterId) {
      return { ...token, clusterBoundaries: null };
    }

    let xProps = [];
    let yProps = [];

    // First, push my coords in.
    xProps.push(token.x);
    yProps.push(token.y);

    for (let peerId in peers) {
      const peer = peers[peerId];
      if (peer.clusterId == token.clusterId) {
        xProps.push(peer.x);
        yProps.push(peer.y);
      }
    }

    const top = Math.min(...yProps);
    const right = Math.max(...xProps);
    const bottom = Math.max(...yProps);
    const left = Math.min(...xProps);

    if (xProps.length && yProps.length) {
      boundaries = { top, right, bottom, left };
    } else {
      boundaries = null;
    }
    return { ...token, clusterBoundaries: boundaries };
  });
}

function toggleMic() {
  update((token) => {
    const isEnabled = token.stream.getAudioTracks()[0].enabled;
    token.stream.getAudioTracks()[0].enabled = !isEnabled;
    return token;
  });
}

export { token };
